import { render } from "./GalleryAddModal.vue?vue&type=template&id=c07637f6&scoped=true"
import script from "./GalleryAddModal.vue?vue&type=script&lang=js"
export * from "./GalleryAddModal.vue?vue&type=script&lang=js"

import "./GalleryAddModal.vue?vue&type=style&index=0&id=c07637f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c07637f6"]])

export default __exports__